import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import StarRating from '../../components/shared/Rating';
import appState from '../../state/AppStateContainer';
import moment from "moment";
import 'moment/locale/sv.js';
import 'moment/locale/nb.js';
import 'moment/locale/da.js';
import { CentralAgreementIcon } from '../../components/svgs';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import BlockIcon from '@material-ui/icons/Block';
import SupplierBlockedReasons from './supplier-blocked-reasons';
import SupplierControls from '../app-add-supplier/supplier-controls';
import File from '../../components/File/File';
import { FileScope, PrequalificationDecision } from '../../util/appEnum';
import { getImageUrl } from '../../components/shared/ImagePreview/ImagePreview';
import BtButton from '../bt-button/bt-button';
import { ServiceSupplier } from '../../services/service-supplier';
import * as Sentry from "@sentry/react";
import { ServiceDashboard } from '../../services/service-dashboard';
import PlaceSelector from '../page-supplier-presentation/PlaceSelector';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg';
import { ReactComponent as VerifiedIcon } from '../../assets/svg/verifiedIcon.svg';
import { ReactComponent as MonitoringIcon } from "../../assets/svg/monitor-icon.svg";
import { ReactComponent as ClipIcon } from '../../assets/svg/clip.svg';
import { Trans, useTranslation } from 'react-i18next';
import Modal from '../../components/shared/Modal/Modal';
import { Form, Mode, readFormFromDB } from '../../components/shared/Form/Form';
import { ServiceSupplierApplicationForm } from '../../services/service-supplier-application-form';
import { ServiceDownload } from '../../services/service-download';
import BoxHolder from '../../components/shared/BoxHolder/BoxHolder';
import BoxHolderHeader from '../../components/shared/BoxHolder/BoxHolderHeader';
import Tabs from '../../components/shared/Tabs';
import SimpleFile from '../../components/SimpleFile/SimpleFile';
import ProjectRow from '../../components/ProjectRow/ProjectRow';
import { projectTypeToIconMap } from '../page-projects/page-projects-start';
import ConversationModal from '../../components/shared/ConversationModal/ConversationModal';
import ConversationButton from '../../components/shared/ConversationModal/ConversationButton';
import { useProjectPhases } from '../../util/projectPhases';
import hasValidFile from '../../util/validFile';
import DatePicker from '../../components/shared/DatePicker/DatePicker';
import Field from '../../components/shared/Field/Field';
import NotesPencilIcon from '../../components/svgs/notesPencilIcon';
import HTMLParser from '../../components/shared/HTMLParser/HTMLParser';
import ContractIcon from '../../components/svgs/contractIcon';
import FileUploadRow from '../../components/shared/FileUploadRow/FileUploadRow';
import ContactRow from '../../components/shared/ContactRow/ContactRow';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { formatAmount } from '../../util';

const formatDateTime = (date) => date ? moment(date).locale(appState.state.language ?? 'sv').format('LL LT') : '';

const SupplierProfileName = ({ supplierValue, supplierProfileValue, renderValue = x => x, isMonitored }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierDetailPanel.profileField' });

  const monitorTooltip = () => {
    return isMonitored && (
      <TooltipContainer renderReferenceComponent={(className, ref) => (
        <div className={className} ref={ref} style={{ position: 'relative', width: 'fit-content', height: 'fit-content', display: 'inherit', marginLeft: '8px', }}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0L11.2249 2.15239L14.2901 1.71885L14.8249 4.76795L17.5595 6.21885L16.2 9L17.5595 11.7812L14.8249 13.2321L14.2901 16.2812L11.2249 15.8476L9 18L6.77508 15.8476L3.70993 16.2812L3.17508 13.2321L0.440492 11.7812L1.8 9L0.440492 6.21885L3.17508 4.76795L3.70993 1.71885L6.77508 2.15239L9 0Z" fill="#E5E7EB"></path></svg>
          <MonitoringIcon style={{
            width: '10px',
            height: '10px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            color: 'var(--gray-500)',
            transform: 'translate(-50%, -50%)',
          }}
          />
        </div>
      )}>
        <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
          <p style={{ marginTop: 0 }}><b>{t('monitorTooltip.heading', 'Bevakning')}</b></p>
          {t('monitorTooltip.info', 'Leverantören bevakas i Syna.')}
        </div>
      </TooltipContainer>
    )
  }
  if (!supplierProfileValue?.trim()) return <>{renderValue(supplierValue)}{monitorTooltip()}</>;
  if (!supplierValue?.trim()) return <>{renderValue(supplierProfileValue)}{monitorTooltip()}</>;
  if (supplierValue?.trim() == supplierProfileValue?.trim()) {
    return (<div style={{ display: 'flex', alignItems: 'center' }}>
      {renderValue(supplierValue)}
      {<TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />}>
        <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
          <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
          {t('info.matchesSuppliersValue', 'Matchar leverantörens egna uppgifter.')}
        </div>
      </TooltipContainer>}
      {monitorTooltip()}
    </div>);
  }

  // Check if supplierProfileValue is a URL, and make it a clickable link if so. Don't use renderValue or monitorTooltip.
  const isUrl = (val) => typeof val === 'string' && /^https?:\/\//i.test(val.trim());

  return (<div style={{ display: 'flex', alignItems: 'center' }}>
    {renderValue(supplierValue)}
    {<TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px" }} />}>
      <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
        <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
        {`${t('info.valueFromSupplier', 'Leverantören har angett')} `}{isUrl(supplierProfileValue) ? <a className="detail-sec-sub-field" href={supplierProfileValue}>{supplierProfileValue}</a> : <span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{supplierProfileValue}</span>}
      </div>
    </TooltipContainer>}
    {monitorTooltip()}
  </div>);
}

const SupplierProfileField = ({ title, supplierValue, supplierProfileValue, renderValue = x => x }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierDetailPanel.profileField' });
  if (!supplierProfileValue?.trim()) return <div>{title}{renderValue(supplierValue)}</div>;
  if (!supplierValue?.trim()) return <div>{title}{renderValue(supplierProfileValue)}</div>;
  if (supplierValue?.trim() == supplierProfileValue?.trim()) {
    return (<div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {title}
        {<TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />}>
          <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
            <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
            {t('info.matchesSuppliersValue', 'Matchar leverantörens egna uppgifter.')}
          </div>
        </TooltipContainer>}
      </div>
      {renderValue(supplierValue)}
    </div>
    );
  }

  // Check if supplierProfileValue is a URL, and make it a clickable link if so. Don't use renderValue or monitorTooltip.
  const isUrl = (val) => typeof val === 'string' && /^https?:\/\//i.test(val.trim());
  return (<div>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {title}
      {<TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px" }} />}>
        <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
          <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
          {`${t('info.valueFromSupplier', 'Leverantören har angett')} `}{isUrl(supplierProfileValue) ? <a className="detail-sec-sub-field" href={supplierProfileValue}>{supplierProfileValue}</a> : <span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{supplierProfileValue}</span>}
        </div>
      </TooltipContainer>}
    </div>
    {renderValue(supplierValue)}
  </div>
  );

}

const FileSectionKey = {
  FRAMEWORK_AGREEMENTS: 'frameworkAgreements',
  LIABILITY_INSURANCES: 'liabilityInsurances',
  UE2021_FORMS: 'ue2021Forms',
  OTHER_FILES: 'otherFiles',
};

const SupplierDetailPanel = ({
  rowData,
  supId,
  hasSyna,
  hasCreditsafe,
  hasTic,
  onFeaturedSupplierSubmit,
  history,
}) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierDetailPanel' });
  const { purchasePhasesMap, projectPhasesMap, purchasePhaseToName, projectPhaseToName } = useProjectPhases();

  const [contacts, setContacts] = useState(rowData.supMember);
  const [newContacts, setNewContacts] = useState([]);
  const [editingContact, setEditingContact] = useState(null);
  const [contactErrorMessages, setContactErrorMessages] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [applicationFormVisibility, setApplicationFormVisibility] = useState(false);
  const [supplierApplicationForm, setSupplierApplicationForm] = useState();
  const [loadingSupplierApplicationForm, setLoadingSupplierApplicationForm] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [supplierStatistics, setSupplierStatistics] = useState(null);
  const [loadingSupplierStatistics, setLoadingSupplierStatistics] = useState(false);
  const [supplierProjects, setSupplierProjects] = useState(null);
  const [loadingSupplierProjects, setLoadingSupplierProjects] = useState(false);
  const [fileSections, setFileSections] = useState({
    [FileSectionKey.FRAMEWORK_AGREEMENTS]: rowData.frameworkAgreements || [],
    [FileSectionKey.LIABILITY_INSURANCES]: rowData.liabilityInsurances || [],
    [FileSectionKey.UE2021_FORMS]: rowData.ue2021Forms || [],
    [FileSectionKey.OTHER_FILES]: rowData.otherFiles || [],
  });
  const [newFiles, setNewFiles] = useState({
    [FileSectionKey.FRAMEWORK_AGREEMENTS]: [],
    [FileSectionKey.LIABILITY_INSURANCES]: [],
    [FileSectionKey.UE2021_FORMS]: [],
    [FileSectionKey.OTHER_FILES]: [],
  });
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const [currentSectionKey, setCurrentSectionKey] = useState(null);
  const [supplierComments, setSupplierComments] = useState([]);
  const [editingFile, setEditingFile] = useState(null); // { sectionKey, index }
  const [focusedDatePicker, setFocusedDatePicker] = useState(null); // { sectionKey, index, isNew }
  const otherFilesInputRef = React.useRef(null);
  const tabIndex = {
    GENERAL: 0,
    CONTACTS: 1,
    STATISTICS: 2,
    FILES: 3,
  }

  const statistics = [
    { title: t('usage.statistics.sentBidRequests', 'Antal skickade budförfrågningar'), value: supplierStatistics?.sentBidRequests, tooltip: t('usage.statistics.sentBidRequestsTooltip', '') },
    { title: t('usage.statistics.submittedBids', 'Antal inlämnade anbud'), value: supplierStatistics?.submittedBids, tooltip: t('usage.statistics.submittedBidsTooltip', '') },
    { title: t('usage.statistics.bidResponseRate', 'Biresponsfrekvens'), value: supplierStatistics?.bidResponseRate, tooltip: t('usage.statistics.bidResponseRateTooltip', ''), symbol: '%' },
    { title: t('usage.statistics.responseRate', 'Svarsfrekvens'), value: supplierStatistics?.responseRate, tooltip: t('usage.statistics.responseRateTooltip', ''), symbol: '%' },
    { title: t('usage.statistics.jobsWon', 'Antal vunna jobb'), value: supplierStatistics?.jobsWon, tooltip: t('usage.statistics.jobsWonTooltip', '') },
    { title: t('usage.statistics.totalContractedAmount', 'Totalt kontrakterat belopp'), value: supplierStatistics?.totalContractedAmount, tooltip: t('usage.statistics.totalContractedAmountTooltip', ''), symbol: ' kr' },
    { title: t('usage.statistics.ataAverage', 'ÄTA% genomsnitt'), value: supplierStatistics?.ataAverage, tooltip: t('usage.statistics.ataAverageTooltip', ''), symbol: '%' },
    { title: t('usage.statistics.ataAverageSupCat', 'ÄTA%-genomsnitt för leverantörskategorierna'), value: supplierStatistics?.ataAverageSupCat, tooltip: t('usage.statistics.ataAverageSupCatTooltip', ''), symbol: '%' },
  ]

  const supplierProfile = rowData.supplierProfile;

  const fetchSupplierComments = async () => {
    const comments = await ServiceSupplier.getSupplierComments(supId);
    setSupplierComments(comments || []);
    return comments || [];
  }

  // Update contacts when rowData changes
  useEffect(() => {
    setContacts(rowData.supMember);
    setNewContacts([]);
    setEditingContact(null);
    setContactErrorMessages({});
    if (rowData.sup_id) {
      setLoadingSupplierStatistics(true);
      ServiceSupplier.getSupplierStatistics(rowData.sup_id).then(statistics => {
        setSupplierStatistics(statistics);
        setLoadingSupplierStatistics(false);
      }).catch(error => {
        console.error(error);
      });
      setLoadingSupplierProjects(true);
      ServiceSupplier.getSupplierProjects(rowData.sup_id).then(projects => {
        setSupplierProjects(projects);
        setLoadingSupplierProjects(false);
      }).catch(error => {
        console.error(error);
      });
    }
  }, [rowData]);

  // Update file sections when rowData changes
  useEffect(() => {
    setFileSections({
      [FileSectionKey.FRAMEWORK_AGREEMENTS]: rowData.frameworkAgreements || [],
      [FileSectionKey.LIABILITY_INSURANCES]: rowData.liabilityInsurances || [],
      [FileSectionKey.UE2021_FORMS]: rowData.ue2021Forms || [],
      [FileSectionKey.OTHER_FILES]: rowData.otherFiles || [],
    });
  }, [rowData]);
  const supplierAreaIds = rowData.areaArray.map(a => a._id).sort().join(",");
  const profileAreaIds = supplierProfile?.areas.map(a => a._id).sort().join(",");
  const supplierProfileAreas = (supplierAreaIds != profileAreaIds) ? supplierProfile.areas.map(a => a.name) : [];

  const loadSupplierApplicationForm = async () => {
    if (!rowData.supplierApplicationFormId) {
      return;
    }

    if (!supplierApplicationForm) {
      setLoadingSupplierApplicationForm(true);
      const form = await ServiceSupplierApplicationForm.getSupplierApplicationForm(rowData.supplierApplicationFormId);
      setSupplierApplicationForm(readFormFromDB(form, Mode.READ));

      setLoadingSupplierApplicationForm(false);
    }
    setApplicationFormVisibility(true);
  }

  const renderTitle = (title, noBorder = false) => (
    <div className={`detail-sec-title ${noBorder ? 'no-border' : ''}`}>
      <span className="detail-sec-title-title">{title}</span>
    </div>
  );
  const renderSubTitle = (title) => (
    <span className="detail-sec-sub-title-title">{title}</span>
  );

  const renderFileDateAndComment = (item, activeLabel, inactiveLabel, expiresLabel, scope, scopeOptions) => {
    let active = false;
    let end;
    const pickedDate = item.validUntilDate || item.submittedDate;
    if (pickedDate) {
      end = new Date(pickedDate);
      end.setHours(23, 59, 59, 999);
      active = new Date() < end;
    }
    return <React.Fragment>
      <div className="sp-control-row">
        {item.file &&
          <File
            style={{ marginTop: '5px', display: 'flex' }}
            file={item.file.file}
            fileName={item.file.fileName}
            scope={scope ?? FileScope.SupplierFiles}
            scopeOptions={scopeOptions ?? {
              supplierId: supId
            }}
          />
        }
        {(activeLabel || inactiveLabel) && (<div key="indicator">
          {pickedDate && (
            <>
              {active ? (
                <div className="collective-agreementFlag true">
                  <CheckIcon /> {activeLabel}
                </div>
              ) : (
                <div className="collective-agreementFlag false">
                  <CloseIcon /> {inactiveLabel}
                </div>
              )}
            </>
          )}
        </div>
        )}
        {end &&
          <span>{expiresLabel + " " + end.toLocaleDateString()}</span>
        }
      </div>
      <div className="contact-email-and-phone" style={{ marginTop: "-14px", marginBottom: "16px" }}>
        {item.comment}
      </div>
    </React.Fragment>
  }

  const renderRowWithExpiration = (item, label, desc) => {
    let active = false;
    let end;
    const pickedDate = item.validUntilDate;
    if (pickedDate) {
      end = new Date(pickedDate);
      end.setHours(23, 59, 59, 999);
      active = new Date() < end;
    }

    const activeLabel = t('liabilityInsurance.activeLabel', 'Aktiv')
    const inactiveLabel = t('liabilityInsurance.inactiveLabel', 'Utgången')
    const expiresLabel = active ? t('liabilityInsurance.expiresLabel', 'Giltig till') : t('frameworkAgreement.invalidSinceLabel', 'Ogiltig sedan')
    return <React.Fragment>
      <div className="sp-control-row">
        <div className="sp-control-item-with-desc">
          <b>{label}</b>
          {desc ? <span className="sup-controls-desc">{desc}</span> : end &&
            <span className="sup-controls-desc">{expiresLabel + " " + moment(end).locale(appState.state.language ?? 'sv').format('L')}</span>
          }
        </div>
        {(activeLabel || inactiveLabel) && (<div key="indicator">
          {pickedDate ? (
            <>
              {active ? (
                <div className="collective-agreementFlag true">
                  <CheckIcon /> {activeLabel}
                </div>
              ) : (
                <div className="collective-agreementFlag false">
                  <CloseIcon /> {inactiveLabel}
                </div>
              )}
            </>
          ) : <div></div>}
        </div>
        )}
        {!active ? <BtButton color='white' size='xxs' onClick={() => setSelectedTab(tabIndex.FILES)}>{t('supplierControls.view', 'Visa')}</BtButton> : <div></div>}
      </div>
    </React.Fragment>
  }

  const renderRowWithFile = (item, label) => {
    if (!item) return;
    return (item?.file?.file || item?.file?.fileName || item?.validUntilDate || item?.comment) &&
      <React.Fragment>
        {renderRowWithExpiration(item, label)}
      </React.Fragment>
  }

  const renderUE2021Form = (item) => {
    if (!item) return;
    return item && (item.file || item.submittedDate || item.comment) &&
      <React.Fragment>
        {renderRowWithExpiration(item, t('ue2021.title', 'UE2021'), item.comment)}
      </React.Fragment>
  }

  const addFeaturedSupplierToRegistry = async (supplierId) => {
    setIsLoading(true);
    if (!supplierId) return;

    try {
      const response = await ServiceSupplier.addFeaturedSupplierToRegistry(supplierId);
      onFeaturedSupplierSubmit(response.name);
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  }

  const showFormButton = <BtButton loaderShow={loadingSupplierApplicationForm} onClick={() => loadSupplierApplicationForm()} color='white' size='xxs'>{t('application.viewForm', 'Visa formulär')}</BtButton>;
  const frameworkAgreement = hasValidFile(rowData.frameworkAgreements ?? []);
  const supplierNameRow = (<>
    {rowData.centralAgreements?.length > 0 &&
      <TooltipContainer renderReferenceComponent={
        (className, ref) => <CentralAgreementIcon color="var(--orange-500)" style={{ marginRight: '10px', marginLeft: '0', flexShrink: 0 }} className={className} innerRef={ref} />
      }>
        <div style={{ maxWidth: "300px", fontSize: "14px", color: "var(--gray-700)", fontWeight: 400 }}>
          {t('centralAgreementInfo', 'Detta centralt upphandlade ramavtal tillhandahålls av Accurator i samarbete med vår partner Procava.')}
        </div>
      </TooltipContainer>
    }
    <SupplierProfileName supplierProfileValue={supplierProfile.name} supplierValue={rowData.sup_name} isMonitored={rowData.isMonitored} />
  </>)

  // Calculate framework agreement status

  let frameworkActive = false;
  let frameworkEnd;

  if (frameworkAgreement) {
    const pickedDate = frameworkAgreement.validUntilDate;
    if (pickedDate) {
      frameworkEnd = new Date(pickedDate);
      frameworkEnd.setHours(23, 59, 59, 999);
      frameworkActive = new Date() < frameworkEnd;
    }
  }

  const frameworkAgreementRow = frameworkAgreement ? (<>
    <span>{t('frameworkAgreement.title', 'Ramavtal')}</span>
    <TooltipContainer renderReferenceComponent={(className, ref) => (
      !frameworkAgreement ? (
        <div className={className + " collective-agreementFlag false noMargin"} ref={ref}><CloseIcon /></div>
      ) : (
        <div className={className} ref={ref}>
          {frameworkActive || !frameworkAgreement.validUntilDate ?
            <div className={"collective-agreementFlag true noMargin"} > <CheckIcon /> </div> :
            <div className={"collective-agreementFlag false noMargin"} > <CloseIcon /> </div>
          }
        </div>
      )
    )}>
      {!frameworkAgreement ? (
        <span>{t('frameworkAgreement.no', 'Inget ramavtal')}</span>
      ) : (
        <span>
          {(frameworkActive || !frameworkAgreement.validUntilDate
            ? t('frameworkAgreement.activeLabel', 'Aktivt')
            : t('frameworkAgreement.inactiveLabel', 'Utgånget')) +
            (frameworkAgreement.validUntilDate ?
              " | " + (frameworkActive ? t('frameworkAgreement.expiresLabel', 'Giltigt till') : t('frameworkAgreement.invalidSinceLabel', 'Ogiltig sedan')) +
              (frameworkEnd ? " " + moment(frameworkEnd).locale(appState.state.language ?? 'sv').format('L') : "") : '')}
        </span>
      )}
    </TooltipContainer>
  </>) : null

  const experienceRow = rowData.projectsCount ? (
    <StarRating className="rating-component gray-star" rating={rowData.rating} numberOfStars={1} readOnly numberFirst={true} fullSymbol="fa fa-star" />
  ) :
    null

  const blockedRow = rowData.isBlacklist && (<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
    {t('filter.blocked.placeholder', 'Spärrade')}
    <span className="blacklistWarningHover blacklistSupDetails">
      <TooltipContainer renderReferenceComponent={(className, ref) => <BlockIcon style={{ marginRight: '10px' }} className={className} innerRef={ref} />}>
        {rowData.reasons?.length > 0 && (
          <SupplierBlockedReasons reasons={rowData.reasons} />
        )}
      </TooltipContainer>
    </span>
  </div>
  )

  const buildTabs = () => {
    return [
      t('tabs.general', 'Allmänt'),
      t('contacts.title', 'Kontaktpersoner'),
      t('title.statistics', 'Statistik'),
      t('tabs.files', 'Filer'),
    ]
  }

  const buildGeneralTab = () => {
    const liabilityInsurance = hasValidFile(rowData.liabilityInsurances ?? []);
    const profileLiabilityInsurance = hasValidFile(supplierProfile.liabilityInsurances ?? []);
    const ue2021Form = hasValidFile(rowData.ue2021Forms ?? []);
    return (
      <div className="sup-details-tab-content">
        <BoxHolder className="box-holder-gap">
          {renderTitle(t('profileInfo.title', 'Leverantörsprofil'), true)}
          {(rowData.address || supplierProfile.address) && (<div>
            <SupplierProfileField
              title={renderSubTitle(t('profileInfo.address.title', 'Adress'))}
              supplierProfileValue={supplierProfile.address}
              supplierValue={rowData.address}
              renderValue={value => <span className="detail-sec-sub-field">{value}</span>}
            />
          </div>)}
          {(rowData.website || supplierProfile.website) && (<div>
            <SupplierProfileField
              title={renderSubTitle(t('profileInfo.website.title', 'Webbplats'))}
              supplierProfileValue={supplierProfile.website}
              supplierValue={rowData.website}
              renderValue={value => <a className="detail-sec-sub-field" href={(value?.includes('://') ? '' : 'https://') + value}>{value}</a>}
            />
          </div>)}
          <div>
            {renderSubTitle(<>{t('profileInfo.areas.title', 'Yrkesområden')}
              {supplierProfileAreas.length > 0 && (
                <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />}>
                  <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                    <b>{t('profileInfo.areas.tooltip.title', 'Leverantörsprofil')}</b><br />
                    {`${t('profileInfo.areas.tooltip.valueFromSupplier', 'Leverantören har angett', { supplierProfileAreas })} `}<span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{supplierProfileAreas.join(', ')}</span>
                  </div>
                </TooltipContainer>
              )}
            </>)}
            <div>
              <PlaceSelector places={rowData.areaArray?.map(a => a.name) ?? []} readonly />
            </div>
          </div>
          {(supplierProfile.places?.length > 0 || rowData.places?.length > 0) && (<div>
            {renderSubTitle(<>{t('profileInfo.places.title', 'Platser')}
              <TooltipContainer renderReferenceComponent={(className, ref) => {
                return (
                  <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />
                )
              }}>
                <div style={{ maxWidth: "400px" }}>{t('profileInfo.places.info', 'Driftsområden kan läggas till av både dig och leverantören. De som leverantören lägger till kommer att prioriteras vid visning.')}</div>
              </TooltipContainer>
            </>, true)}
            <PlaceSelector places={supplierProfile.places?.length > 0 ? supplierProfile.places : rowData.places} readonly />
          </div>)}
          {supplierProfile.presentation && (
            <div>
              {renderSubTitle(t('profileInfo.supDescription.title', 'Leverantörens beskrivning'))}
              <span className="detail-sec-sub-field">{supplierProfile.presentation}</span>
            </div>
          )}
          {rowData.description && (
            <div>
              {renderSubTitle(t('profileInfo.description.title', 'Egen beskrivning'))}
              <span className="detail-sec-sub-field">{rowData.description}</span>
            </div>
          )}
          <div>
            {renderSubTitle(t('registration.title', 'Registreringsinformation'))}
            {rowData?.application ? (
              <>
                {rowData?.prequalification?.decidedAt && (<div >
                  <div className="detail-sec-sub-field" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                    {t(
                      'application.prequalificationDecision',
                      'Ansökan: {{context}} den {{decidedAt}} av {{decidedBy}}',
                      {
                        context: rowData?.prequalification.decision,
                        decidedAt: formatDateTime(rowData?.prequalification.decidedAt),
                        decidedBy: rowData?.prequalification.decidedByName
                      }
                    )}
                    {rowData.supplierApplicationFormId && showFormButton}
                  </div>
                </div>)}
                {rowData?.prequalification.decision == PrequalificationDecision.INBOX && (<>
                  <div className="detail-sec-sub-field" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                    {t(
                      'application.inboxed.info',
                      'Inskickad den {{createdAt}} av {{applicantInfo}}.',
                      {
                        createdAt: formatDateTime(rowData?.createdAt),
                        applicantInfo: [
                          rowData?.application?.applicant?.name,
                          rowData?.application?.applicant?.title,
                          rowData?.application?.applicant?.email,
                          rowData?.application?.applicant?.phone,
                        ].filter(x => x).join(', ')
                      }
                    )}
                    {rowData.supplierApplicationFormId && showFormButton}
                  </div>

                  {rowData?.application?.message && (<>
                    <p className="detail-sec-sub-field" style={{ whiteSpace: "pre-line" }}>
                      <span style={{ fontWeight: "bold" }}>{t('application.inboxed.messageTitle', 'Meddelande')}</span><br />
                      {rowData?.application?.message}
                    </p>
                  </>)}
                </>)}
                {appState.getCurrentOrgSlug() === 'superadmin' && (<>
                  <div className='sp-control-row' style={{ marginTop: 16 }}><b>{t('application.label.invoiceAddress', 'Fakturaadress')}</b> {rowData?.application?.invoiceAddress}</div>
                  <div className='sp-control-row'><b>{t('application.label.invoiceReference', 'Märkning/referens')}</b> {rowData?.application?.invoiceReference}</div>
                  <div className='sp-control-row'><b>{t('application.label.invoiceInterval', 'Avtalslängd')}</b> {rowData?.application?.invoiceInterval}</div>
                </>)}
              </>
            ) : (
              <div className="detail-sec-sub-field">
                {rowData.importId ? (
                  t(
                    'registration.imported',
                    'Importerad den {{date}}',
                    { date: formatDateTime(rowData.createdAt) }
                  )
                ) : (
                  t(
                    'registration.created',
                    'Skapad den {{date}}',
                    { context: rowData.createdByName ? 'name' : null, date: formatDateTime(rowData.createdAt), name: rowData.createdByName }
                  )
                )}
              </div>
            )}
          </div>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: supplierComments.length === 0 ? '8px' : '0' }}>
            {renderSubTitle(t('comments.title', 'Kommentarer'))}
            <div className='sup-details-comments-container' >
              <ConversationModal
                title={t('comments.title', 'Kommentarer')}
                fetchConversation={async () => await fetchSupplierComments()}
                updateConversation={async (content) => {
                  const updatedComments = await ServiceSupplier.updateSupplierComments(supId, content);
                  setSupplierComments(updatedComments || []);
                  return updatedComments;
                }}
                render={(hasContent, content, openModal, count, author, date) => {
                  return <ConversationButton hasContent={hasContent} content={content} openModal={openModal} count={count} author={author} date={date} />;
                }}
              />
            </div>
          </div>
        </BoxHolder>
        <BoxHolder>
          <SupplierControls
            organizationNumber={rowData.organizationNumber}
            hasSyna={hasSyna}
            hasCreditsafe={hasCreditsafe}
            hasTic={hasTic}
            history={history}
            className="sup-details-controls-holder"
          >
            {renderRowWithFile(liabilityInsurance, t('liabilityInsurance.title', 'Ansvarsförsäkring'))}
            {renderRowWithFile(
              profileLiabilityInsurance,
              t('liabilityInsurance.profileInfoTitle', 'Ansvarsförsäkring från leverantörsprofil'),
            )}
            {ue2021Form && renderUE2021Form(ue2021Form)}
            {rowData.projectsCount > 0 && (
              <div className="sp-control-row">
                <div className="sp-control-item-with-desc">
                  <b>{t('experience.title', 'Erfarenheter')}</b>
                  {rowData.lastRatedAt && <span className="sup-controls-desc">{t('label.submittedAt', 'Senast inlämnad den {{date}}', { date: moment(rowData.lastRatedAt).locale(appState.state.language ?? 'sv').format('L') })}</span>}
                </div>
                <div>
                  <StarRating className="rating-component gray-star" rating={rowData.rating} numberOfStars={1} readOnly numberFirst={true} fullSymbol="fa fa-star" />
                </div>
                {<BtButton color='white' size='xxs' onClick={() => history.push(`/${appState.getCurrentOrgSlug()}/rating/${supId}/true`)}>{t('experience.evaluation.button', 'Visa utvärderingar')}</BtButton>}
              </div>
            )}
          </SupplierControls>
        </BoxHolder>
      </div>
    )
  }

  const saveContact = async (contact, index, isNew) => {
    setContactErrorMessages({});

    try {
      let result;
      if (isNew) {
        // Add new member
        result = await ServiceSupplier.saveSupplierMember({
          supplierId: supId,
          name: contact.name,
          email: contact.email,
          title: contact.title,
          phone: contact.phone,
        });
      } else {
        // Update existing member
        result = await ServiceSupplier.updateSupplierMember({
          supplierMemberId: contact._id,
          name: contact.name,
          email: contact.email,
          title: contact.title,
          phone: contact.phone,
        });
      }

      if (result.fieldErrorMessages) {
        const errorKey = isNew ? contact.key : contact._id;
        setContactErrorMessages({ [errorKey]: result.fieldErrorMessages });
        return;
      }

      // Refresh contacts from server
      const updatedMembers = await ServiceSupplier.getSupplierMembers(supId);
      setContacts(updatedMembers || []);

      if (isNew) {
        const newArr = [...newContacts];
        newArr.splice(index, 1);
        setNewContacts(newArr);
      }

      setEditingContact(null);
      setContactErrorMessages({});
      NotificationManager.success(t('notification.contactSaved', 'Kontakt sparad'));
    } catch (error) {
      console.error('Error saving contact:', error);
      const errorKey = isNew ? contact.key : contact._id;
      if (error.response?.data?.fieldErrorMessages) {
        setContactErrorMessages({ [errorKey]: error.response.data.fieldErrorMessages });
      } else {
        NotificationManager.error(t('notification.contactSaveError', 'Fel vid sparande av kontakt'));
      }
    }
  };

  const removeContact = async (contact, index, isNew) => {
    if (!window.confirm(t('confirm.removeContact', 'Är du säker på att du vill ta bort denna kontaktperson?'))) {
      return;
    }

    if (isNew) {
      const newArr = [...newContacts];
      newArr.splice(index, 1);
      setNewContacts(newArr);
      setEditingContact(null);
      return;
    }

    try {
      await ServiceSupplier.updateSupplierMember({
        supplierMemberId: contact._id,
        isActive: false,
      });

      const updatedMembers = await ServiceSupplier.getSupplierMembers(supId);
      setContacts(updatedMembers || []);

      setEditingContact(null);
      NotificationManager.success(t('notification.contactRemoved', 'Kontakt borttagen'));
    } catch (error) {
      console.error('Error removing contact:', error);
      NotificationManager.error(t('notification.contactRemoveError', 'Fel vid borttagning av kontakt'));
    }
  };

  const buildContactsTab = () => {
    const isEditingContact = (index, isNew) => {
      return editingContact && editingContact.index === index && editingContact.isNew === isNew;
    };

    const cleanupEmptyNewContactsAndEdit = (index, isNew) => {
      if (editingContact && editingContact.isNew) {
        const newArr = [...newContacts];
        newArr.splice(editingContact.index, 1);
        setNewContacts(newArr);

        if (isNew && index > editingContact.index) {
          index = index - 1;
        }
      }
      setEditingContact({ index, isNew });
    };

    const renderProfileInfo = (d) => {
      const otherEmailAddress = supplierProfile.otherEmailAddresses.find(o => o.email == d.email);
      const contact = supplierProfile.contacts.find(c => c.email == d.email);

      if (contact) {
        const diff = [
          contact.name && contact.name != d.name && <div>{t('profileInfo.diff.label.name', 'Namn')}: {contact.name}</div>,
          contact.title && contact.title != d.title && <div>{t('profileInfo.diff.label.title', 'Titel')}: {contact.title}</div>,
          contact.phone && contact.phone != d.phone && <div>{t('profileInfo.diff.label.phone', 'Telefon')}: {contact.phone}</div>,
        ].filter(x => x);
        return (
          <div>
            <TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} />}>
              <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                {diff.length ? <>
                  {t('profileInfo.diff.intro', 'E-postadressen matchar leverantörens egna uppgifter, men följande uppgifter skiljer sig:')}
                  {diff}
                </> : t('profileInfo.diff.intro', 'Kontaktpersonen matchar leverantörens egna uppgifter.', { context: 'noDiff' })}
              </div>
            </TooltipContainer>
          </div>
        );
      }

      const comment = otherEmailAddress?.comment;
      if (otherEmailAddress?.redirectTo) {
        const supplierProfileContact = supplierProfile.contacts.find(c => c._id == otherEmailAddress.redirectTo);
        const email = supplierProfileContact?.email;
        const contact = contacts.find(c => c.email == email);
        const name = contact?.name ?? supplierProfileContact?.name;
        if (name) {
          return (
            <div>
              <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} />}>
                <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                  {
                    comment ? (
                      <Trans t={t} i18nKey="profileInfo.otherEmailAddress.redirectTo_withComment" values={{ name, comment }}>
                        Leverantören rekommenderar: Kontakta <span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{{ name }}</span> i stället ({{ comment }}).
                      </Trans>
                    ) : (
                      <Trans t={t} i18nKey="profileInfo.otherEmailAddress.redirectTo">
                        Leverantören rekommenderar: Kontakta <span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{{ name }}</span> i stället.
                      </Trans>
                    )
                  }
                </div>
              </TooltipContainer>
            </div>
          );
        }
      } else if (comment) {
        return (
          <div>
            <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} />}>
              <div style={{ maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                <Trans t={t} i18nKey="profileInfo.otherEmailAddress.comment" values={{ comment }}>
                  Meddelande från leverantören: <span style={{ fontWeight: 500, color: 'var(--gray-900)' }}>{{ comment }}</span>
                </Trans>
              </div>
            </TooltipContainer>
          </div>
        );
      }
      return null;
    }

    return (
      <div className="sup-details-tab-content">
        <BoxHolder className="box-holder-gap">
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {renderTitle(t('contacts.title', 'Kontaktpersoner'), true)}
            <BtButton
              color="white"
              size="xxs"
              style={{ width: 'fit-content' }}
              onClick={() => {
                cleanupEmptyNewContactsAndEdit(newContacts.length, true);
                setNewContacts([...newContacts, { key: `${Date.now()}`, name: '', email: '', title: '', phone: '' }]);
              }}
            >
              {t('comment.button.add', 'Lägg till')}
            </BtButton>
          </div>

          <div className="sup-details-contacts-list">
            {contacts.map((contact, index) => {
              const isEditing = isEditingContact(index, false);

              const profileInfo = renderProfileInfo(contact);
              return (
                <ContactRow
                  profileInfo={profileInfo}
                  key={contact._id || `contact-${index}`}
                  contact={contact}
                  index={index}
                  isEditing={isEditing}
                  canEdit={true}
                  canRemove={true}
                  onEdit={() => cleanupEmptyNewContactsAndEdit(index, false)}
                  onSave={(updatedContact) => saveContact(updatedContact, index, false)}
                  onCancel={() => setEditingContact(null)}
                  onRemove={() => removeContact(contact, index, false)}
                  errorMessages={contactErrorMessages[contact._id]}
                />
              );
            })}
            {newContacts.map((contact, index) => {
              const isEditing = isEditingContact(index, true);
              return (
                <ContactRow
                  key={contact.key || `new-contact-${index}`}
                  contact={contact}
                  index={index}
                  isEditing={isEditing}
                  canEdit={true}
                  canRemove={true}
                  onEdit={() => cleanupEmptyNewContactsAndEdit(index, true)}
                  onSave={(updatedContact) => saveContact(updatedContact, index, true)}
                  onCancel={() => {
                    const newArr = [...newContacts];
                    newArr.splice(index, 1);
                    setNewContacts(newArr);
                    setEditingContact(null);
                  }}
                  onRemove={() => removeContact(contact, index, true)}
                  onChange={(field, value) => {
                    const newArr = [...newContacts];
                    newArr[index] = { ...newArr[index], [field]: value };
                    setNewContacts(newArr);
                  }}
                  errorMessages={contactErrorMessages[contact.key]}
                />
              );
            })}
          </div>
        </BoxHolder>
        <BoxHolder className="box-holder-gap">
          {renderTitle(t('recommendedContacts.title', 'Leverantörens föreslagna kontaktpersoner'), true)}
          <div className="sup-details-contacts-list">
            {supplierProfile.contacts?.map((contact, index) => {
              return (
                <ContactRow
                  key={contact._id || `recommended-contact-${index}`}
                  contact={contact}
                  index={index}
                  isEditing={false}
                  canEdit={false}
                  canRemove={false}
                />
              );
            })}
          </div>
        </BoxHolder>
      </div>
    )
  }

  const buildStatisticsRow = ({ title, value, tooltip, symbol, index }) => {
    return (
      <div className="sup-details-statistics-row" key={'statistics-row-' + index}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ maxWidth: '280px', display: 'inline-block' }}>{title}</span>
          {tooltip && <TooltipContainer renderReferenceComponent={(className, ref) => (
            <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />
          )}>
            <div style={{ color: 'var(--gray-700)', maxWidth: '350px' }}><span style={{ whiteSpace: 'pre-line' }}>{tooltip.replace(/\\n/g, "\n")}</span></div>
          </TooltipContainer>}
        </div>
        {(!value || value === '0') ? <span>{!symbol ? '0' : '-'}</span> : <span>{formatAmount(value)}{symbol}</span>}
      </div>
    )
  }

  const buildStatisticsTab = () => {
    return (
      <div className="sup-details-tab-content">
        <BoxHolder className="box-holder-gap">
          {renderTitle(t('usage.statistics.title', 'Användningsstatistik'), true)}
          {loadingSupplierStatistics && <div>{t('loading', 'Laddar...')}</div>}
          {!loadingSupplierStatistics && !supplierStatistics && <div>{t('no.statistics', 'Ingen statistik hittades')}</div>}
          {!loadingSupplierStatistics && supplierStatistics && (<div className="sup-details-statistics-list">
            {statistics.map((statistic, index) => {
              return (
                buildStatisticsRow({ title: statistic.title, value: statistic.value, tooltip: statistic.tooltip, symbol: statistic.symbol, index: index })
              )
            })}
          </div>)}
        </BoxHolder>
        <BoxHolder className="box-holder-gap-half">
          {renderTitle(t('projects.title', 'Projekts'), true)}
          {loadingSupplierProjects && <div>{t('loading', 'Laddar...')}</div>}
          {!loadingSupplierProjects && !supplierProjects && <div>{t('no.projects', 'Inga projekt hittades')}</div>}
          {!loadingSupplierProjects && supplierProjects && (<div className="sup-details-projects-list">
            {supplierProjects.map((project) => {
              return project.area.map((p, index) => {
                const purchasePhase = purchasePhaseToName(p.step);
                let projectPhase;
                if (!project.isOpen) {
                  projectPhase = t('project.phase.finished', 'Avslutat');
                } else if (project.phase) {
                  projectPhase = projectPhaseToName(project.phase);
                } else {
                  projectPhase = t('project.phase.active', 'Pågående');
                }
                const { hasWon, noWinnerPicked } = p;
                return (
                  <ProjectRow
                    key={project._id + index}
                    symbol={project.projectTypeName ? <TooltipContainer renderReferenceComponent={(className, ref) => projectTypeToIconMap({ width: 18, height: 18, className, ref })[project.projectTypeName]}><span style={{ color: 'var(--gray-700)', fontSize: '12px' }}>{project.projectTypeName}</span></TooltipContainer> : undefined}
                    name={project.name}
                    areaName={p.areaName}
                    purchasePhase={purchasePhase}
                    projectPhase={projectPhase}
                    wonOrNot={!noWinnerPicked && `(${hasWon ? t('project.selected', 'vald') : t('project.notSelected', 'ej vald')})`}
                    slug={project.slug}
                    areaSlug={p.areaSlug}
                  />
                )
              })
            })}
          </div>)}
        </BoxHolder>
      </div>
    )
  }
  // ========== FILE SECTION CONFIGURATION ==========
  const FILE_SECTION_CONFIG = {
    [FileSectionKey.FRAMEWORK_AGREEMENTS]: {
      supportsComment: true,
      supportsValidUntilDate: true,
      allowsMetadataOnly: true,
      backendKey: 'existingFrameworkAgreements',
      newBackendKey: 'newFrameworkAgreements',
    },
    [FileSectionKey.LIABILITY_INSURANCES]: {
      supportsComment: true,
      supportsValidUntilDate: true,
      allowsMetadataOnly: true,
      backendKey: 'existingLiabilityInsurances',
      newBackendKey: 'newLiabilityInsurances',
    },
    [FileSectionKey.UE2021_FORMS]: {
      supportsComment: true,
      supportsValidUntilDate: false,
      supportsSubmittedDate: true,
      allowsMetadataOnly: true,
      backendKey: 'existingUE2021Forms',
      newBackendKey: 'newUE2021Forms',
    },
    [FileSectionKey.OTHER_FILES]: {
      supportsComment: false,
      supportsValidUntilDate: false,
      allowsMetadataOnly: false,
      backendKey: 'existingOtherFiles',
      newBackendKey: 'newOtherFiles',
    },
  };

  const getSectionConfig = (sectionKey) => FILE_SECTION_CONFIG[sectionKey] || {};

  // ========== FILE VALIDATION ==========
  const validateFileEntry = (file, sectionKey) => {
    const config = getSectionConfig(sectionKey);
    const hasFile = file?.file?.file || file?.file || file?.replacementFile;
    const hasMetadata =
      (config.supportsComment && file?.comment) ||
      (config.supportsValidUntilDate && file?.validUntilDate) ||
      (config.supportsSubmittedDate && file?.submittedDate);

    // Other Files MUST have a file (no metadata-only)
    if (!config.allowsMetadataOnly && !hasFile) {
      return {
        isValid: false,
        error: t('notification.error.fileRequired', 'Övriga filer måste ha en fil'),
      };
    }

    // For sections with metadata, require either file or metadata
    if (!hasFile && !hasMetadata && config.allowsMetadataOnly) {
      return {
        isValid: false,
        error: t('notification.error.metadataRequired', 'Poster utan fil måste ha minst ett datum eller en kommentar'),
      };
    }

    return { isValid: true };
  };

  // ========== FILE METADATA HELPERS ==========
  const buildFileMetadataForSection = (file, sectionKey) => {
    const config = getSectionConfig(sectionKey);
    const metadata = { _id: file._id.toString() };

    if (config.supportsComment) {
      metadata.comment = file.comment;
    }
    if (config.supportsValidUntilDate) {
      metadata.validUntilDate = file.validUntilDate;
    }
    if (config.supportsSubmittedDate) {
      metadata.submittedDate = file.submittedDate;
    }

    const hasFile = file.file?.file || file.file;
    if (!hasFile && !file.replacementFile) {
      if (config.allowsMetadataOnly) {
        metadata.fileRemoved = true;
      }
    }

    return metadata;
  };

  const buildExistingFilesData = (sections) => {
    const data = {};

    Object.keys(FILE_SECTION_CONFIG).forEach(sectionKey => {
      const config = FILE_SECTION_CONFIG[sectionKey];
      data[config.backendKey] = (sections[sectionKey] || [])
        .filter(f => {
          if (!f || !f._id) return false;
          const hasFile = f.file?.file || f.file;
          const hasMetadata =
            (config.supportsComment && f.comment) ||
            (config.supportsValidUntilDate && f.validUntilDate) ||
            (config.supportsSubmittedDate && f.submittedDate);

          if (!config.allowsMetadataOnly && !hasFile && !f.replacementFile) {
            return false;
          }

          return true;
        })
        .map(f => buildFileMetadataForSection(f, sectionKey));
    });

    return data;
  };

  const handleRemoveFile = async (sectionKey, index) => {
    const previousSections = { ...fileSections };
    const updatedSections = { ...fileSections };
    if (Array.isArray(updatedSections[sectionKey])) {
      updatedSections[sectionKey] = updatedSections[sectionKey].filter((_, i) => i !== index);
    }

    // Update state immediately for UI feedback
    setFileSections(updatedSections);

    // Actually delete from server
    try {
      const updateData = {
        supplierId: supId,
        ...buildExistingFilesData(updatedSections),
      };
      await ServiceSupplier.updateSupplier(updateData, {});
      NotificationManager.success(t('notification.success.fileRemoved', 'Filen har tagits bort'));
    } catch (error) {
      // Revert state on error
      setFileSections(previousSections);
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    }
  };

  const handleAddFiles = async () => {
    if (!currentSectionKey || newFiles[currentSectionKey].length === 0) return;

    // Validate metadata-only entries have at least a comment or date
    const invalidEntries = newFiles[currentSectionKey].filter(f => !f.file && !f.comment && !f.validUntilDate);
    if (invalidEntries.length > 0) {
      NotificationManager.error(
        t('notification.error.metadataRequired', 'Poster utan fil måste ha minst ett datum eller en kommentar'),
        t('notification.error.validation', 'Valideringsfel')
      );
      return;
    }

    setIsUploadingFiles(true);
    const previousSections = { ...fileSections };
    const updatedSections = { ...fileSections };
    const currentFiles = Array.isArray(updatedSections[currentSectionKey]) ? updatedSections[currentSectionKey] : [];

    // Prepare files for upload - only include actual file objects
    const files = {};
    // Map section keys to their corresponding 'new' array names in the backend
    const newArrayKeyMap = {
      [FileSectionKey.FRAMEWORK_AGREEMENTS]: 'newFrameworkAgreements',
      [FileSectionKey.LIABILITY_INSURANCES]: 'newLiabilityInsurances',
      [FileSectionKey.UE2021_FORMS]: 'newUE2021Forms',
      [FileSectionKey.OTHER_FILES]: 'newOtherFiles',
    };
    const newArrayKey = newArrayKeyMap[currentSectionKey];
    const fileMetadata = [];

    let fileIndex = 0;
    newFiles[currentSectionKey].forEach((fileData) => {
      const metadata = {
        comment: fileData.comment || '',
        submittedDate: fileData.submittedDate || new Date(),
        validUntilDate: fileData.validUntilDate,
        hasFile: !!fileData.file, // Indicate whether this entry has an actual file
      };

      // Only add to files object if there's an actual file
      if (fileData.file) {
        const fileFieldName = `${currentSectionKey}${fileIndex}`;
        files[fileFieldName] = fileData.file;
        fileIndex++;
      }

      fileMetadata.push(metadata);
    });

    // Update state immediately for UI feedback
    // otherFiles uses flat structure (and doesn't support metadata-only), others use nested file object
    const isOtherFiles = currentSectionKey === FileSectionKey.OTHER_FILES;

    updatedSections[currentSectionKey] = [
      ...currentFiles,
      ...newFiles[currentSectionKey].map(f => {
        if (isOtherFiles) {
          // Flat structure for otherFiles (only actual files, no metadata-only)
          return {
            file: null, // Will be populated by server
            fileName: f.file ? f.file.name : '',
            uploadedAt: new Date(),
          };
        } else {
          // Nested structure for frameworkAgreements, liabilityInsurances, ue2021Forms
          return {
            file: f.file ? { file: null, fileName: f.file.name } : null,
            comment: f.comment || '',
            submittedDate: f.submittedDate || new Date(),
            validUntilDate: f.validUntilDate,
          };
        }
      })
    ];
    setFileSections(updatedSections);

    // Actually upload to server
    try {
      const existingFilesData = buildExistingFilesData(fileSections);

      const updateData = {
        supplierId: supId,
        ...existingFilesData,
        [newArrayKey]: fileMetadata || [],
      };

      const result = await ServiceSupplier.updateSupplier(updateData, files);

      // Update state with server response
      setFileSections(prev => ({
        ...prev,
        [currentSectionKey]: result[currentSectionKey] || prev[currentSectionKey],
      }));

      NotificationManager.success(t('notification.success.filesAdded', 'Filerna har lagts till'));
      setNewFiles(prev => ({
        ...prev,
        [currentSectionKey]: []
      }));
      setCurrentSectionKey(null);
    } catch (error) {
      // Revert state on error
      setFileSections(previousSections);
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      setIsUploadingFiles(false);
    }
  };

  const addEmptyFileEntry = (sectionKey) => {
    setCurrentSectionKey(sectionKey);
    setNewFiles(prev => ({
      ...prev,
      [sectionKey]: [...prev[sectionKey], {
        key: `file_${Date.now()}_${Math.random()}`,
        file: null,
        comment: '',
        submittedDate: new Date(),
        validUntilDate: null,
      }]
    }));
  };

  const updateFileInModal = (sectionKey, index, field, value) => {
    setNewFiles(prev => {
      const updated = [...prev[sectionKey]];
      updated[index] = { ...updated[index], [field]: value };
      return {
        ...prev,
        [sectionKey]: updated
      };
    });
  };

  const updateExistingFileField = (sectionKey, index, field, value) => {
    setFileSections(prev => {
      const updatedSections = { ...prev };
      const files = [...updatedSections[sectionKey]];
      files[index] = { ...files[index], [field]: value };
      updatedSections[sectionKey] = files;
      return updatedSections;
    });
  };

  // ========== FILE FIELDS RENDERING ==========
  const renderFileFields = (file, sectionKey, index, isNewFile = false) => {
    const config = getSectionConfig(sectionKey);
    const fields = [];
    const updateField = isNewFile ? updateFileInModal : updateExistingFileField;

    if (config.supportsComment) {
      fields.push(
        <Field
          key="comment"
          label={t('field.comment', 'Kommentar')}
          value={file.comment || ''}
          onChange={(value) => updateField(sectionKey, index, 'comment', value)}
        />
      );
    }

    if (config.supportsValidUntilDate) {
      fields.push(
        <DatePicker
          key="validUntilDate"
          label={t('field.validUntilDate', 'Giltig till')}
          selected={file.validUntilDate ? new Date(file.validUntilDate) : null}
          onChange={(date) => updateField(sectionKey, index, 'validUntilDate', date)}
          onFocus={() => setFocusedDatePicker({ sectionKey, index, isNew: isNewFile })}
          onBlur={() => setFocusedDatePicker(null)}
          isClearable
        />
      );
    }

    if (config.supportsSubmittedDate) {
      fields.push(
        <DatePicker
          key="submittedDate"
          label={t('field.submittedDate', 'Inlämnad den')}
          selected={file.submittedDate ? new Date(file.submittedDate) : null}
          onChange={(date) => updateField(sectionKey, index, 'submittedDate', date)}
          onFocus={() => setFocusedDatePicker({ sectionKey, index, isNew: isNewFile })}
          onBlur={() => setFocusedDatePicker(null)}
          isClearable
        />
      );
    }

    return fields;
  };

  const removeFileFromModal = (sectionKey, index) => {
    setNewFiles(prev => ({
      ...prev,
      [sectionKey]: prev[sectionKey].filter((_, i) => i !== index)
    }));
  };

  const handleDirectFileUpload = async (sectionKey, selectedFiles) => {
    if (!selectedFiles || selectedFiles.length === 0) return;

    setIsUploadingFiles(true);
    const previousSections = { ...fileSections };
    const updatedSections = { ...fileSections };
    const currentFiles = Array.isArray(updatedSections[sectionKey]) ? updatedSections[sectionKey] : [];
    const config = getSectionConfig(sectionKey);

    try {
      const files = {};
      const fileMetadata = [];

      Array.from(selectedFiles).forEach((file, index) => {
        files[`${sectionKey}${index}`] = file;
        fileMetadata.push({
          submittedDate: new Date(),
          hasFile: true,
        });
      });

      // Update state immediately for UI feedback
      const newFileEntries = Array.from(selectedFiles).map(file => ({
        _id: `temp-${Date.now()}-${Math.random()}`,
        fileName: file.name,
        file: URL.createObjectURL(file),
        uploadedAt: new Date(),
      }));

      updatedSections[sectionKey] = [...currentFiles, ...newFileEntries];
      setFileSections(updatedSections);

      // Upload to server
      const updateData = {
        supplierId: supId,
        ...buildExistingFilesData(updatedSections),
        [config.newBackendKey]: fileMetadata,
      };

      const result = await ServiceSupplier.updateSupplier(updateData, files);

      // Update with actual server response
      setFileSections(prev => ({
        ...prev,
        [sectionKey]: result[sectionKey] || prev[sectionKey],
      }));

      NotificationManager.success(t('notification.success.filesAdded', 'Filerna har lagts till'));
    } catch (error) {
      // Revert state on error
      setFileSections(previousSections);
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      setIsUploadingFiles(false);
    }
  };

  const buildFileRow = ({ file, fileName, comment, submittedDate, validUntilDate, scope, scopeOptions, sectionKey, index, canEdit, uploadedBy, noFileNameTitle, fullFileObject }) => {
    const filePath = typeof file === 'string' ? file : undefined;
    const hasFile = filePath && fileName;
    const hasMetadata = comment || validUntilDate || submittedDate;

    const isDisabled = !hasFile && !hasMetadata;
    const isEditing = editingFile && editingFile.sectionKey === sectionKey && editingFile.index === index;

    if (isEditing && canEdit) {
      // Render FileUploadRow for editing
      return (
        <FileUploadRow
          existingFile={{
            ...fullFileObject,
            fileName: fileName,
            file: filePath,
            comment: comment || '',
            validUntilDate: validUntilDate,
          }}
          setExistingFile={(updatedFile) => {
            if (updatedFile === null) {
              setEditingFile(null);
            } else {
              const updatedSections = { ...fileSections };
              const files = [...updatedSections[sectionKey]];
              const updatedFileEntry = {
                ...files[index],
                comment: updatedFile.comment,
                validUntilDate: updatedFile.validUntilDate,
                replacementFile: updatedFile.replacementFile,
              };

              // Handle file removal (file set to undefined means remove it)
              if (updatedFile.file === undefined && updatedFile.fileName === undefined) {
                updatedFileEntry.file = null;
              }

              files[index] = updatedFileEntry;
              updatedSections[sectionKey] = files;
              setFileSections(updatedSections);
            }
          }}
          newFile={null}
          setNewFile={() => { }}
          label={t('label.selectFile', 'Välj fil')}
          hasRemoveButton={true}
          allowMetadataOnly={getSectionConfig(sectionKey).allowsMetadataOnly}
          isDatePickerFocused={focusedDatePicker && focusedDatePicker.sectionKey === sectionKey && focusedDatePicker.index === index && focusedDatePicker.isNew === false}
          onSave={async () => {
            const currentFile = fileSections[sectionKey][index];
            const validation = validateFileEntry(currentFile, sectionKey);

            if (!validation.isValid) {
              NotificationManager.error(
                validation.error,
                t('notification.error.validation', 'Valideringsfel')
              );
              return;
            }

            setIsUploadingFiles(true);
            try {
              const config = getSectionConfig(sectionKey);
              const files = {};

              if (currentFile.replacementFile) {
                const sectionsForUpdate = { ...fileSections };
                sectionsForUpdate[sectionKey] = sectionsForUpdate[sectionKey].filter(
                  (_, i) => i !== index
                );

                const allSectionsData = buildExistingFilesData(sectionsForUpdate);
                files[`${sectionKey}0`] = currentFile.replacementFile;

                const metadata = {
                  submittedDate: currentFile.submittedDate || new Date(),
                  hasFile: true,
                };

                if (config.supportsComment) {
                  metadata.comment = currentFile.comment || '';
                }
                if (config.supportsValidUntilDate) {
                  metadata.validUntilDate = currentFile.validUntilDate;
                }
                if (config.supportsSubmittedDate) {
                  metadata.submittedDate = currentFile.submittedDate;
                }

                const updateData = {
                  supplierId: supId,
                  ...allSectionsData,
                  [config.newBackendKey]: [metadata],
                };

                const result = await ServiceSupplier.updateSupplier(updateData, files);
                setFileSections(prev => ({
                  ...prev,
                  [sectionKey]: result[sectionKey] || prev[sectionKey],
                }));
              } else {
                const allSectionsData = buildExistingFilesData(fileSections);
                const updateData = {
                  supplierId: supId,
                  ...allSectionsData,
                };

                const result = await ServiceSupplier.updateSupplier(updateData, {});
                setFileSections(prev => ({
                  ...prev,
                  [sectionKey]: result[sectionKey] || prev[sectionKey],
                }));
              }

              NotificationManager.success(t('notification.success.fileUpdated', 'Filen har uppdaterats'));
              setEditingFile(null);
            } catch (error) {
              const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
              NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
              Sentry.captureException(error);
            } finally {
              setIsUploadingFiles(false);
            }
          }}
          renderFields={(file) => renderFileFields(file, sectionKey, index, false)}
        />
      );
    }

    return (
      <SimpleFile
        file={filePath}
        fileName={fileName}
        comment={comment}
        submittedDate={submittedDate}
        validUntilDate={validUntilDate}
        scope={scope}
        scopeOptions={scopeOptions}
        disabled={isDisabled}
        canEdit={canEdit}
        onRemove={canEdit && sectionKey && index !== undefined ? () => handleRemoveFile(sectionKey, index) : undefined}
        onEdit={canEdit && sectionKey !== null && sectionKey !== FileSectionKey.OTHER_FILES && index !== undefined ? () => setEditingFile({ sectionKey, index }) : undefined}
        uploadedBy={uploadedBy}
        noFileNameTitle={noFileNameTitle}
      />
    )
  }

  const renderFileSection = ({ titleKey, defaultTitle, fileData, sectionKey, canEdit = false, scope, scopeOptions }) => {
    const files = Array.isArray(fileData) ? fileData.filter(f => f) : [fileData].filter(f => f);
    const isOtherFiles = sectionKey === FileSectionKey.OTHER_FILES;

    const handleAddClick = () => {
      if (isOtherFiles && canEdit) {
        // For Other Files, directly open file browser
        otherFilesInputRef.current?.click();
      } else {
        // For other sections, use default flow
        addEmptyFileEntry(sectionKey);
      }
    };

    const handleFileInputChange = (e) => {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        handleDirectFileUpload(sectionKey, selectedFiles);
      }
      e.target.value = '';
    };

    return (
      <BoxHolder>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          {renderTitle(t(titleKey, defaultTitle), true)}
          {canEdit && sectionKey && (
            <>
              <BtButton
                color="white"
                size="xxs"
                style={{ width: 'fit-content', marginTop: '12px', marginBottom: '12px' }}
                onClick={handleAddClick}
                loaderShow={isUploadingFiles && isOtherFiles}
              >
                {t('comment.button.add', 'Lägg till')}
              </BtButton>
              {isOtherFiles && (
                <input
                  ref={otherFilesInputRef}
                  type="file"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleFileInputChange}
                />
              )}
            </>
          )}
        </div>

        {files.map((file, index) => (
          <React.Fragment key={file._id || `file-${index}`}>
            {buildFileRow({
              file: file?.file?.file || file?.file,
              fileName: file?.file?.fileName || file?.fileName,
              comment: file?.comment,
              submittedDate: file?.submittedDate || file?.uploadedAt,
              validUntilDate: file?.validUntilDate,
              sectionKey,
              index,
              canEdit,
              uploadedBy: file?.uploadedBy,
              scope: scope ?? FileScope.SupplierFiles,
              scopeOptions: scopeOptions ?? { supplierId: supId },
              noFileNameTitle: t(titleKey, defaultTitle),
              fullFileObject: file,
            })}
          </React.Fragment>
        ))}

        {files.length === 0 && <SimpleFile noFile={true} disabled={true} />}
        {newFiles[sectionKey]?.length > 0 && newFiles[sectionKey].map((fileEntry, index) => (
          <FileUploadRow
            key={fileEntry.key}
            existingFile={null}
            setExistingFile={() => { }}
            newFile={fileEntry}
            setNewFile={(updatedFile) => {
              if (updatedFile === null) {
                removeFileFromModal(sectionKey, index);
              } else {
                // Update the file property (can be undefined if removed)
                setNewFiles(prev => {
                  const updated = [...prev[sectionKey]];
                  updated[index] = {
                    ...updated[index],
                    file: updatedFile.file
                  };
                  return {
                    ...prev,
                    [sectionKey]: updated
                  };
                });
              }
            }}
            label={t('label.selectFile', 'Välj fil')}
            hasRemoveButton={true}
            allowMetadataOnly={getSectionConfig(sectionKey).allowsMetadataOnly}
            isDatePickerFocused={focusedDatePicker && focusedDatePicker.sectionKey === sectionKey && focusedDatePicker.index === index && focusedDatePicker.isNew === true}
            onSave={async () => {
              const currentFile = newFiles[sectionKey][index];
              const validation = validateFileEntry(currentFile, sectionKey);

              if (!validation.isValid) {
                NotificationManager.error(
                  validation.error,
                  t('notification.error.validation', 'Valideringsfel')
                );
                return;
              }

              setIsUploadingFiles(true);
              const previousSections = { ...fileSections };
              const updatedSections = { ...fileSections };
              const currentFiles = Array.isArray(updatedSections[sectionKey]) ? updatedSections[sectionKey] : [];
              const config = getSectionConfig(sectionKey);

              try {
                const files = {};
                const metadata = {
                  submittedDate: currentFile.submittedDate || new Date(),
                  hasFile: !!currentFile.file,
                };

                // Only include fields that this section supports
                if (config.supportsComment) {
                  metadata.comment = currentFile.comment || '';
                }
                if (config.supportsValidUntilDate) {
                  metadata.validUntilDate = currentFile.validUntilDate;
                }
                if (config.supportsSubmittedDate) {
                  metadata.submittedDate = currentFile.submittedDate;
                }

                // Only add to files object if there's an actual file
                if (currentFile.file) {
                  files[`${sectionKey}0`] = currentFile.file;
                }

                const isOtherFiles = sectionKey === FileSectionKey.OTHER_FILES;

                // Update state immediately for UI feedback
                const newFileEntry = isOtherFiles
                  ? {
                    _id: `temp-${Date.now()}`,
                    fileName: currentFile.file?.name || '',
                    file: currentFile.file ? URL.createObjectURL(currentFile.file) : null,
                  }
                  : {
                    _id: `temp-${Date.now()}`,
                    file: {
                      file: currentFile.file ? URL.createObjectURL(currentFile.file) : null,
                      fileName: currentFile.file?.name || '',
                    },
                    comment: metadata.comment,
                    submittedDate: metadata.submittedDate,
                    validUntilDate: metadata.validUntilDate,
                  };

                updatedSections[sectionKey] = [...currentFiles, newFileEntry];
                setFileSections(updatedSections);

                // Remove this file from newFiles
                setNewFiles(prev => ({
                  ...prev,
                  [sectionKey]: prev[sectionKey].filter((_, i) => i !== index)
                }));

                // Upload to server
                const updateData = {
                  supplierId: supId,
                  ...buildExistingFilesData(updatedSections),
                  [config.newBackendKey]: [metadata],
                };

                const result = await ServiceSupplier.updateSupplier(updateData, files);

                // Update with actual server response
                setFileSections(prev => ({
                  ...prev,
                  [sectionKey]: result[sectionKey] || prev[sectionKey],
                }));

                NotificationManager.success(t('notification.success.fileUploaded', 'Filen har laddats upp'));
              } catch (error) {
                // Revert state on error
                setFileSections(previousSections);
                setNewFiles(prev => {
                  const updated = [...prev[sectionKey]];
                  updated.splice(index, 0, currentFile);
                  return { ...prev, [sectionKey]: updated };
                });
                const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
                NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
                Sentry.captureException(error);
              } finally {
                setIsUploadingFiles(false);
              }
            }}
            renderFields={(file) => renderFileFields(file, sectionKey, index, true)}
          />
        ))}

      </BoxHolder>
    );
  };

  const buildFilesTab = () => {
    const canEdit = appState.isAdminRole() || appState.getCurrentOrgSlug() === 'superadmin';

    const sections = [
      { titleKey: 'frameworkAgreement.title', defaultTitle: 'Ramavtal', data: fileSections[FileSectionKey.FRAMEWORK_AGREEMENTS], sectionKey: FileSectionKey.FRAMEWORK_AGREEMENTS, canEdit },
      { titleKey: 'liabilityInsurance.title', defaultTitle: 'Ansvarsförsäkring', data: fileSections[FileSectionKey.LIABILITY_INSURANCES], sectionKey: FileSectionKey.LIABILITY_INSURANCES, canEdit },
      { titleKey: 'ue2021.title', defaultTitle: 'UE2021', data: fileSections[FileSectionKey.UE2021_FORMS], sectionKey: FileSectionKey.UE2021_FORMS, canEdit },
      { titleKey: 'files.other.headline', defaultTitle: 'Övriga filer', data: fileSections[FileSectionKey.OTHER_FILES], sectionKey: FileSectionKey.OTHER_FILES, canEdit },
    ];

    const supplierProfileSections = [
      { titleKey: 'liabilityInsurance.profileInfoTitle', defaultTitle: 'Ansvarsförsäkring från leverantörsprofil', data: supplierProfile.liabilityInsurances, sectionKey: null, canEdit: false, scope: FileScope.SupplierProfileFile, scopeOptions: { organizationNumber: supplierProfile?.orgNr } },
      { titleKey: 'files.supplier.other.headline', defaultTitle: 'Övriga filer från leverantörsprofil', data: supplierProfile.existingFiles, sectionKey: null, canEdit: false, scope: FileScope.SupplierProfileFile, scopeOptions: { organizationNumber: supplierProfile?.orgNr } },
    ];

    return (
      <div className="sup-details-files-grid">
        <div className="sup-details-files-column">
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            {renderFileSection({
              titleKey: section.titleKey,
              defaultTitle: section.defaultTitle,
              fileData: section.data,
              sectionKey: section.sectionKey,
              canEdit: section.canEdit,
              scope: section.scope,
              scopeOptions: section.scopeOptions,
            })}
          </React.Fragment>
        ))}
        </div>
        <div className="sup-details-files-column">
          {supplierProfileSections.map((section, index) => (
            <React.Fragment key={index}>
              {renderFileSection({
                titleKey: section.titleKey,
                defaultTitle: section.defaultTitle,
                fileData: section.data,
                sectionKey: section.sectionKey,
                canEdit: section.canEdit,
                scope: section.scope,
                scopeOptions: section.scopeOptions,
              })}
            </React.Fragment>
          ))}
        </div>

      </div>
    );
  }

  const renderTabContent = () => {
    switch (selectedTab) {
      case tabIndex.GENERAL:
        return buildGeneralTab();
      case tabIndex.CONTACTS:
        return buildContactsTab();
      case tabIndex.STATISTICS:
        return buildStatisticsTab();
      case tabIndex.FILES:
        return buildFilesTab();
      default:
        return null;
    }
  };

  return (
    <div className="sp-row-detail-wrapper-wrapper">
      <div className="sp-row-detail-wrapper">
        <div className="ar-row">
          <div className="ar-column detail-left-col" style={{ paddingTop: '32px' }}>
            <BoxHolderHeader
              imageUrl={(() => {
                const logoFile = supplierProfile?.logo?.file ?? rowData.logo?.file;
                const isSupplierProfileLogo = logoFile?.includes('/supplierProfile/');
                const scope = isSupplierProfileLogo ? FileScope.SupplierProfileLogo : FileScope.SupplierLogo;
                const scopeOptions = isSupplierProfileLogo
                  ? { organizationNumber: supplierProfile.orgNr }
                  : { supplierId: supId };
                return getImageUrl(logoFile, appState.getCurrentOrgSlug(), scope, scopeOptions);
              })()}
              content={[
                supplierNameRow,
                rowData.organizationNumber,
                frameworkAgreementRow,
                experienceRow,
                blockedRow
              ]}>
              {(rowData.isFeatured && appState.getCurrentOrgSlug() !== 'superadmin') && (
                <BtButton
                  style={{ marginLeft: '16px', fontSize: '14px', cursor: !rowData?.exists ? 'cursor' : 'default' }}
                  loaderShow={isLoading}
                  disabled={rowData?.exists}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!rowData?.exists) {
                      ServiceDashboard.logRegistryAddition(rowData.sup_id)
                      addFeaturedSupplierToRegistry(rowData.sup_id);
                    }
                  }}>
                  {rowData?.exists ?
                    t('button.alreadyExists', 'Redan tillagt i registret')
                    : (appState.isAdminRole() ? t('button.add', 'Lägg till i registret') : t('button.addApplication', 'Lägg till som ansökan'))}
                </BtButton>
              )}
            </BoxHolderHeader>
          </div>
        </div>

        <div className="ar-row">
          <div className="ar-column detail-left-col" style={{ marginBottom: '20px' }}>
            <Tabs tabs={buildTabs()} selected={selectedTab} onChange={(index) => setSelectedTab(index)} style={{ marginBottom: '20px' }} />
            {renderTabContent()}
          </div>
        </div>

      </div>
      {rowData.supplierApplicationFormId && supplierApplicationForm && (
        <Modal
          title={t('application.modal.title', 'Formulär')}
          show={applicationFormVisibility}
          setShow={(value) => setApplicationFormVisibility(value)}
        >
          <div style={{ width: '710px' }} onClick={(e) => {
            if (e.target.className == 'supplierApplicationFormFile') {
              e.preventDefault();
              const blobPath = e.target.dataset['file'];
              const mimeType = e.target.dataset['mime'];
              const fileName = e.target.dataset['name'];
              ServiceDownload.downloadFile(blobPath, mimeType, fileName, FileScope.SupplierFiles, { supplierId: rowData.sup_id });
            }
          }}>
            <Form
              form={supplierApplicationForm}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}

export default SupplierDetailPanel;
